<template>
  <BaseVeeForm :action="submit" v-slot="formProps" @success="closeModal">
    <VModal ref="modal" disable-backdrop-click @close="$emit('close')">
      <div class="mx-auto bg-white rounded-lg text-left shadow-xl lg:max-w-lg sm:w-full">
        <div class="flex flex-col divide-y">
          <div class="flex-none p-4">
            <div class="flex justify-between items-center">
              <div class="flex-1">Save query</div>
              <div class="flex-none">
                <button
                  type="button"
                  class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click="closeModal"
                >
                  <span class="sr-only">Close</span>
                  <svg
                    class="inline-flex h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="flex-1 p-4 space-y-8">
            <BaseFormTextFieldWithValidator
              v-model="formData.name"
              :validator="{
                name: 'name',
                vid: 'name',
                rules: {
                  required: true,
                },
              }"
              :field="{
                label: 'Name',
                id: 'saved_query_name',
              }"
              :disabled="formProps.isPending"
            />
            <BaseFormTextareaFieldWithValidator
              v-model="formData.description"
              :validator="{
                name: 'name',
                vid: 'name',
                rules: {
                  required: false,
                },
              }"
              :field="{
                label: 'Description',
                id: 'saved_query_description',
              }"
              :disabled="formProps.isPending"
            />
            <div class="flex space-x-2">
              <BaseButton primary> Save </BaseButton>
              <BaseButton type="button" ghost @click="$refs.modal.close()"> Cancel </BaseButton>
            </div>
          </div>
        </div>
      </div>
    </VModal>
  </BaseVeeForm>
</template>

<script>
export default {
  name: 'CreateSavedQueryModal',
  props: {
    action: {
      type: Function,
      default: () => Promise.resolve(),
    },
    query: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        name: '',
        description: '',
      },
    };
  },
  methods: {
    async submit() {
      try {
        await this.action({
          ...this.formData,
          query: this.query,
        });

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    closeModal() {
      this.$refs.modal.close();
    },
  },
};
</script>
